import ServiceApi from '@/services/ServiceApi.js';
import UtilBytes from '@/utils/UtilBytes.js';
import UtilResponseException from "@/utils/UtilResponseException.js";

export default class ServiceWidgetAdMetrix {
  static _microserviceName = 'free';

  static _requestRoutes = {
    getAdMetrixKit: "/admetrix/set-calc",
    downloadAdmetrix: "/admetrix/export-file"
  };

  static async getAdMetrixKit(adMetrixItemId = "", countDays = 0) {
    const requestBody = {
      set_id: adMetrixItemId,
      admetrix: { days: countDays }
    };

    try {
      const responseBody = await ServiceApi.post(this._microserviceName, this._requestRoutes.getAdMetrixKit, requestBody);
      
      return this.getAdMetrixKitAfter(responseBody);
    } catch (error) {
      throw UtilResponseException.getMessage(error);
    }
  }

  static getAdMetrixKitAfter(responseBody = {}) {
    const error = responseBody?.data?.message ?? '';
    const adMetrixData = responseBody?.data?.data ?? {};
    const buildRfData = this._getBuildRfData(adMetrixData);

    const exportKey = adMetrixData?.export_key ?? '';
    const params = !error ? [
      { name: "Кол-во дней", value: buildRfData?.ndays ?? "" },
      { name: "Размещений", value: buildRfData?.esparIdsCount ?? "" },
      { name: "OTS", value: buildRfData?.campaign_ots ?? "" },
      { name: "GRP", value: buildRfData?.campaign_grp ?? "" },
      { name: "Средний GRP", value: buildRfData?.campaign_grp_avg ?? "" },
      { name: "Frequency", value: buildRfData?.campaign_freq ?? "" },
      { name: "Reach", value: buildRfData?.campaign_reach ?? "" },
      { name: "Reach 5+", value: buildRfData?.campaign_reach_5 ?? "" },
      { name: "Reach 10+", value: buildRfData?.campaign_reach_10 ?? "" },
      { name: "Reach 15+", value: buildRfData?.campaign_reach_15 ?? "" },
      { name: "Reach 20+", value: buildRfData?.campaign_reach_20 ?? "" },
      { name: "Население 18+", value: buildRfData?.population ?? "" },
    ] : [];
    
    return { error, params, exportKey };
  }

  static _getBuildRfData(adMetrixData = {}) {
    const buildRfDataItems = [
      adMetrixData?.build_rf_approx?.result,
      adMetrixData?.build_rf_extra?.result,
      adMetrixData?.build_rf?.result,
      adMetrixData?.build_rf_approx,
      adMetrixData?.build_rf_extra,
      adMetrixData?.build_rf
    ];
    
    return buildRfDataItems.find(buildRfDataItem => buildRfDataItem && typeof buildRfDataItem === 'object' && Object.keys(buildRfDataItem).length) ?? {};
  }

  static async downloadAdMetrix(exportKey = "") {
    try {
      const responseBody = await ServiceApi.get(this._microserviceName, this._requestRoutes.downloadAdmetrix, { exportKey });
      const fileBlobData = UtilBytes.base64ToBlob(responseBody?.data?.data?.file ?? "", 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

      return fileBlobData
    } catch (error) {
      throw UtilResponseException.getMessage(error);
    }
  }
}